import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setWarehouseStatsToggleStatus } from "../../../redux/slices/ScanPrint/ScanPrintslice";

function ToggleDetails() {
  const dispatch = useDispatch();
  const Status = useSelector((state) => state.scan.WarehouseStatsToggleStatus);

  return (
    <div className="flex items-center justify-center w-full mt-8 mb-6">
    <label htmlFor="toggleB" className="flex items-center ">
      <div className="relative">
        <input id="toggleB" className="sr-only" />
          <div className="block bg-cyan-100 w-96 h-10 rounded-full">
            <div className="flex flex-row justify-evenly pt-3">
              <p
                onClick={() => dispatch(setWarehouseStatsToggleStatus("General"))}
                className=" text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
              >
               General
              </p>
              <p
                onClick={() => dispatch(setWarehouseStatsToggleStatus("Layout"))}
                className=" text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
              >
               Layout
              </p>
              <p
                onClick={() => dispatch(setWarehouseStatsToggleStatus("Stock"))}
                className="text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
              >
                Stock
              </p>
            </div>
          </div>
            {Status === "General" ? (
              <div className="absolute left-8 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                General
              </div>
            ) : null}
            {Status === "Layout" ? (
              <div className="absolute left-36 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                Layout
              </div>
            ) : null}
            {Status === "Stock" ? (
              <div className="absolute left-64 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                Stock
              </div>
            ) : null}
      </div>
    </label>
  </div>
  );
}

export default ToggleDetails;
